import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

export async function ListProveedorAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<ProveedorInterface>> {
  const { data } = await apiClient.get<ProveedorInterface>(
    "/gpProveedoresProducto",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Proveedor de productos obtenidas correctamente",
  };
}
